import $ from 'jquery';

let $slides, $currentSlide, $nextSlide;
const jQuerySlides = [];

$(function() {
    window.setInterval(changeSlide, 5000);
});

function changeSlide() {
    if ($slides == null) {
        initSlides();
    }

    setCurrentAndNextSlide();
    startSlideChange();
}

function initSlides() {
    $slides = $('.main-image-laptop-slideshow-slide');

    for (var i = 0; i < $slides.length; i++) {
        jQuerySlides.push($($slides[i]));
    }
}

function setCurrentAndNextSlide() {
    for (var i = 0; i < jQuerySlides.length; i++) {
        if (jQuerySlides[i].hasClass('current')) {
            $currentSlide = jQuerySlides[i];
            $nextSlide = i < jQuerySlides.length - 1 ? jQuerySlides[i + 1] : jQuerySlides[0];

            break;
        }
    }
}

function startSlideChange() {
    if (!$currentSlide || !$nextSlide)
        return;

    $currentSlide.addClass('out--next');
    $nextSlide.addClass('in--next');

    window.setTimeout(endSlideChange, 500);
}

function endSlideChange() {
    $currentSlide.removeClass('current');
    $currentSlide.removeClass('out--next');

    $nextSlide.addClass('current');
    $nextSlide.removeClass('in--next');
}
